module.exports = __webpack_public_path__ + "img/renovation-landlord.23e217cd.svg";